export const LOAD_TAX_RATES = 'load_tax_rates';
export const LOAD_TAX_RATE = 'load_tax_rate';
export const TAX_RATES_LOADED = 'set_loaded_tax_rates';
export const TAX_RATE_LOADED = 'set_loaded_tax_rate';
export const SAVE_TAX_RATE = 'save_tax_rate';
export const TAX_RATE_SAVED = 'tax_rate_saved';
export const TAX_RATE_DELETED = 'tax_rate_deleted';
export const RESET_TAX_RATES = 'reset_tax_rates';
export const RESET_SEARCH_TAX_RATES = 'reset_search_tax_rates';
export const SYNC_FAILED = 'tax_rates_sync_error';
export const LOAD_TAX_RATES_TYPES = 'load_tax_rates_types';
export const TAX_RATES_TYPES_LOADED = 'tax_rates_types_loaded';
export const SYNC_FAILED_TAX_RATES_TYPES = 'tax_rates_types_sync_error';
